<template>
  <div class="row reverse-mobile justify-content-center">
    <UserMenu></UserMenu>

    <div class="col-12 col-md-9 center-content">
      <div class="claim p-3 shadow rounded bg-white">
        <h3 class="d-flex align-items-center text-capitalize claim-title">
          <i class="mr-2 material-icons text-secondary">receipt</i>
          Activate License
        </h3>
        <strong class="d-block mt-4 mb-2">Details</strong>
        <div class="d-flex w-40 justify-content-space-between">
          <div class="w-40">
            <ul class="list-unstyled detail-name">
              <li class="d-flex my-1 align-items-center">
                <i class="mr-2 material-icons text-secondary">dvr</i>
                <em>Label</em>
              </li>
              <li class="d-flex my-1 align-items-center">
                <i class="mr-2 material-icons text-secondary">
                  format_list_numbered
                </i>
                <em>Device Id</em>
              </li>
              <li class="d-flex my-1 align-items-center">
                <i class="mr-2 material-icons text-secondary">
                  check_circle_outline
                </i>
                <em>Kit Colour</em>
              </li>
            </ul>
          </div>
          <div class="w-70 mx-4">
            <ul class="list-unstyled text-capitalize detail-value">
              <li class="my-1">
                <em>{{ license.description }}</em>
              </li>
              <li class="my-1">
                <em>{{ deviceInfo.device_id || "&nbsp;" }}</em>
              </li>

              <li class="my-1">
                <em>{{ license.license_colour }}</em>
              </li>
            </ul>
          </div>
        </div>

        <strong class="d-block mt-4 mb-2">Select a kit colour</strong>
        <div class="colour-pick d-flex justify-content- flex-wrap">
          <button
            v-for="color in colors"
            :key="color.name"
            v-bind:class="getColorClass(color)"
            @click="selectColor(color)"
            class="shadow rounded license-colour colour-picker"
          >
            {{ color.name }}
          </button>
        </div>

        <div class="d-block mt-4 mb-2">
          Enter a description or location to help identify this device
        </div>
        <input type="text" class="description-box" v-model="description" />

        <strong class="d-block mt-4 mb-2">Enter device serial number</strong>
        <p id="serial-messages" style="color: red"></p>
        <input type="text" class="serial-number" v-model="deviceSerial" />
        <em class="mb-3 d-block">
          Go to Settings > General > About and then tap-and-hold over Serial
          Number and press Copy. Paste in the box above.
        </em>
        <button class="btn btn-primary mt-2" @click="claim()">
          License Current Device
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import licenseService from "../services/license.service";
import UserMenu from "../components/UserMenu";
import { mapGetters } from "vuex";
import logger from "../utils/logger";

export default {
  name: "MyLicenseV2Claim",
  computed: {
    deviceInfo() {
      return this.$store.getters.getDeviceInfo;
    },
    ...mapGetters("licenseClaimStore", ["license"]),
  },
  methods: {
    getColorClass(color) {
      let returnClass = "kit-" + color.name;
      if (color.selected) {
        let selectedClass = " kit-selected";
        returnClass = returnClass.concat(selectedClass);
      }
      return returnClass;
    },
    selectColor(color) {
      this.colors.forEach((element) => {
        element.selected = false;
      });
      this.colors.forEach((element) => {
        if (color.name === element.name) {
          element.selected = true;
          this.kitColour = element.name;
        }
      });
    },
    claim() {
      if (this.isClaiming) return;
      this.isClaiming = true;
      licenseService
        .claimLicenseV2(
          this.license.uuid_id,
          this.kitColour,
          this.deviceSerial,
          this.description
        )
        .then(
          (response) => {
            logger.log("license.claimed", "License claimed", {
              licenseUuid: this.license.uuid_id,
              deviceSerial: this.deviceSerial,
            });
            if (window.webkit) {
              if (window.webkit.messageHandlers.modvended) {
                window.webkit.messageHandlers.modvended.postMessage({
                  payload: response.license_string,
                });
                this.$router.push("/me/provisioning");
              } else {
                window.webkit.messageHandlers.lvended.postMessage({
                  payload: response.legacy_license_string,
                });
              }
            }

            this.isClaiming = false;
          },
          (reason) => {
            logger.error("license.claim_failed", "License claim failed", {
              licenseUuid: this.license.uuid_id,
              deviceSerial: this.deviceSerial,
              reason,
            });
            alert("There was an error claiming your license. " + reason);
            this.isClaiming = false;
          }
        );
    },
    setRouteParams(param) {
      this.$route.meta.breadcrumb.label = param;
      this.$router.replace({ query: { temp: undefined } });
    },
  },
  data: function () {
    return {
      isClaiming: false,
      kitColour: "",
      deviceSerial: "",
      description: "",
      colors: [
        {
          name: "none",
          selected: true,
          uniqueClass: "kit-none",
        },
        {
          name: "camo",
          selected: false,
          uniqueClass: "kit-camo",
        },
        {
          name: "black",
          selected: false,
          uniqueClass: "kit-black",
        },
        {
          name: "grey",
          selected: false,
          uniqueClass: "kit-grey",
        },
        {
          name: "white",
          selected: false,
          uniqueClass: "kit-white",
        },
        {
          name: "red",
          selected: false,
          uniqueClass: "kit-red",
        },
        {
          name: "orange",
          selected: false,
          uniqueClass: "kit-orange",
        },
        {
          name: "yellow",
          selected: false,
          uniqueClass: "kit-yellow",
        },
        {
          name: "lime",
          selected: false,
          uniqueClass: "kit-lime",
        },
        {
          name: "green",
          selected: false,
          uniqueClass: "kit-green",
        },
        {
          name: "cyan",
          selected: false,
          uniqueClass: "kit-cyan",
        },
        {
          name: "blue",
          selected: false,
          uniqueClass: "kit-blue",
        },
        {
          name: "navy",
          selected: false,
          uniqueClass: "kit-navy",
        },
        {
          name: "purple",
          selected: false,
          uniqueClass: "kit-purple",
        },
        {
          name: "pink",
          selected: false,
          uniqueClass: "kit-pink",
        },
      ],
    };
  },
  components: {
    UserMenu,
  },
  beforeMount() {
    this.licenseId = this.$route.params.licenseUuid;

    const currentColour = this.colors.find(
      (col) => col.name === this.license.license_colour
    );
    if (currentColour) {
      this.selectColor(currentColour);
    } else {
      this.selectColor(this.colors[0]);
    }

    this.description = this.license.description;

    this.setRouteParams("New Claim License: " + this.licenseId);
  },
};
</script>

<style scoped>
.description-box {
  width: 100%;
  padding: 8px;
}

.serial-number {
  letter-spacing: 2rem;
  text-transform: uppercase;
  font-family: console, sans-serif;
  display: block;
  width: 100%;
  margin-bottom: 30px;
  font-size: 30px;
  padding: 7px 20px;

  outline: none !important;
  border-radius: 3px;
  border: 1px solid #ccc;
  background: #efefef;
  color: #333;
}

.colour-pick {
  outline: none !important;
  border-radius: 3px;
  border: 1px solid #ccc;
  background: #efefef;
}

.license-colour {
  display: inline-block;
  height: 95px;
  width: 95px;
  position: relative;
  font-size: 14px;

  margin: 25px 20px;
  font-weight: bold;
  text-transform: capitalize;
}

.kit-selected {
  position: relative;
}

.kit-none {
  background: red; /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(
    left,
    #009ee6,
    #82b753,
    #ffb1e8
  ); /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(
    right,
    #009ee6,
    #82b753,
    #ffb1e8
  ); /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(
    right,
    #009ee6,
    #82b753,
    #ffb1e8
  ); /* For Firefox 3.6 to 15 */
  background: linear-gradient(
    to right,
    #009ee6,
    #82b753,
    #ffb1e8
  ); /* Standard syntax (must be last) */
}
.kit-camo {
  color: white;
  background: red; /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(
    left,
    #1b5e20,
    #a88049,
    #212121
  ); /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(
    right,
    #1b5e20,
    #a88049,
    #212121
  ); /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(
    right,
    #1b5e20,
    #a88049,
    #212121
  ); /* For Firefox 3.6 to 15 */
  background: linear-gradient(
    to right,
    #1b5e20,
    #a88049,
    #212121
  ); /* Standard syntax (must be last) */
}
.kit-black {
  background: #222;
  color: white;
}
.kit-blue {
  background: #009ee6;
}
.kit-green {
  background: #82b753;
}
.kit-lime {
  background: #b2ff59;
}
.kit-grey {
  background: #bab4af;
}
.kit-navy {
  background: #004674;
  color: white;
}
.kit-cyan {
  background: rgb(21, 210, 210);
}
.kit-orange {
  background: #ffaa47;
}
.kit-pink {
  background: #ffb1e8;
}
.kit-purple {
  background: #53246c;
  color: white;
}
.kit-yellow {
  background: #f1e321;
}
.kit-red {
  background: #b80029;
  color: white;
}
.kit-white {
  background: #f4f4f4;
  color: black !important;
}
.selected-colour {
  border-color: #ccc !important;
  outline: none !important;
}

.claim {
  margin-bottom: 30px;
  min-height: 200px;
  overflow: hidden;
}

.claim-title i {
  font-size: 40px;
}

.detail-name em {
  color: var(--isim-light-text);
}

.detail-value em {
  font-style: normal;
}

.kit-selected::after {
  font-family: "Material Icons";
  content: "\E86C";
  -webkit-font-feature-settings: "liga" 1;
  font-feature-settings: "liga" 1;
  top: -5px;
  right: -4px;
  font-size: 24px;
  position: absolute;
  color: #28a745;
  background: white;
  height: 24px;
  width: 25px;
  padding-left: -6px;
  margin: -10px;
  text-align: center;
  line-height: 24px;
  border-radius: 50%;
  margin-left: 22px;
  -webkit-box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
}

/* Anything under iPad Pro */
@media (max-width: 1325px) {
  .license-colour {
    margin: 25px 17px;
    height: 75px;
    width: 75px;
  }
}

/* Anything under iPad Pro 10inch */
@media (max-width: 1075px) {
  .license-colour {
    margin: 17px;
    height: 65px;
    width: 65px;
    font-size: 12px;
  }
}
</style>
